'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
export const pn = {
  Quince: 'quince.com',
  COS: 'cos.com',
  Mango: 'mango.com',
  'Wax London': 'waxlondon.com',
  'Oliver Sweeney': 'oliversweeney.com',
  'Banana Republic': 'bananarepublic.gap.com',
};
export const reference_facts_i = {
  pricing: {
    checked: 'October 6, 2026',
    rows: [
      {
        brand: 'Quince',
        product: 'European Linen Chore Jacket',
        price: 70,
      },
      {
        brand: 'COS',
        product: 'Grandad-Collar Linen Overshirt',
        price: 150,
        sale: 90,
      },
      {
        brand: 'Mango',
        product: '100% Linen Overshirt',
        price: 139.99,
      },
      {
        brand: 'Wax London',
        product: 'Aldred Linen-Cotton Overshirt',
        price: 225,
        sale: 101.25,
      },
      {
        brand: 'Oliver Sweeney',
        product: 'Rauceby Linen Overshirt',
        price: 230,
      },
      {
        brand: 'Banana Republic',
        product: 'Italian Linen-Cotton Shirt Jacket',
        price: 250,
      },
    ],
    target: {
      low: 145,
      high: 165,
      start: 149,
    },
  },
  planner: {
    styles: 8,
    avgMargin: 61.9,
    byStatus: {
      Concept: 2,
      'Tech pack': 2,
      Sampling: 2,
      Approved: 2,
    },
    rows: [
      {
        style: 'Cairn unlined jacket',
        category: 'Jackets',
        colour: 'Driftwood',
        retail: 189,
        cost: 82,
        margin: 56.6,
        status: 'Concept',
      },
      {
        style: 'Fjord boxy overshirt',
        category: 'Overshirts',
        colour: 'Deep Fjord',
        retail: 149,
        cost: 58,
        margin: 61.1,
        status: 'Sampling',
      },
      {
        style: 'Harbour drawstring trouser',
        category: 'Trousers',
        colour: 'Driftwood',
        retail: 129,
        cost: 47,
        margin: 63.6,
        status: 'Tech pack',
      },
      {
        style: 'Kelp pull-on short',
        category: 'Shorts',
        colour: 'Clay',
        retail: 89,
        cost: 31,
        margin: 65.2,
        status: 'Concept',
      },
      {
        style: 'Lantern camp-collar shirt',
        category: 'Shirts',
        colour: 'Sea Fog',
        retail: 109,
        cost: 38,
        margin: 65.1,
        status: 'Approved',
      },
      {
        style: 'Skerry relaxed shirt',
        category: 'Shirts',
        colour: 'Flax',
        retail: 119,
        cost: 42,
        margin: 64.7,
        status: 'Approved',
      },
    ],
  },
  timings: {
    brandKit: '2m 28s',
    directions: '3m 39s',
    channelReply: '28s',
    pricingScan: '2m 4s',
  },
};
export const l = reference_facts_i;
export const researchSources = [...l.pricing.rows]
  .sort((e, t) => e.price - t.price)
  .map((e, t) => ({
    n: t + 1,
    brand: e.brand,
    product: e.product,
    price: e.price,
    sale: 'sale' in e ? e.sale : null,
    domain: pn[e.brand] ?? 'product page',
  }));
export const F = l.pricing.target;
export const hn = l.pricing.checked;
export const gn = l.timings.pricingScan;
export const I = (e) => (Number.isInteger(e) ? `$${e}` : `$${e.toFixed(2)}`);
export const _n = (e) => researchSources.find((t) => t.brand === e)?.n ?? 1;
export const vn = (e, t = !1) => {
  let n = researchSources.find((t) => t.brand === e);
  return n ? I(t && n.sale !== null ? n.sale : n.price) : '';
};
export const yn = 'What do linen overshirts sell for right now?';
export const bn = [
  {
    text: `Full prices run from ${vn('Quince')} at Quince`,
  },
  {
    cite: _n('Quince'),
  },
  {
    text: ` to ${vn('Banana Republic')} at Banana Republic`,
  },
  {
    cite: _n('Banana Republic'),
  },
  {
    text: `. Mango and COS sit at ${vn('Mango')} and ${vn('COS')}`,
  },
  {
    cite: _n('Mango'),
  },
  {
    cite: _n('COS'),
  },
  {
    text: `; COS and Wax London are on sale at ${vn('COS', !0)} and ${vn('Wax London', !0)}`,
  },
  {
    cite: _n('Wax London'),
  },
  {
    text: `. Target ${I(F.low)}–${F.high}, with ${I(F.start)} as the starting point.`,
  },
];
export const xn =
  'No numeric fabric weights were disclosed in the retrieved listings.';
export const Sn = 'USD prices before tax and shipping; sales marked.';
export const Cn = 500;
export const wn = 300;
export const Tn = 2600;
export const En = 70;
export function Dn() {
  let e = [],
    t = Tn;
  for (let n of bn) {
    if ('cite' in n) {
      (e.push({
        kind: 'cite',
        n: n.cite,
        at: t,
      }),
        (t += 140));
      continue;
    }
    for (let r of n.text.split(/(?<=\s)/))
      (e.push({
        kind: 'word',
        text: r,
        at: t,
      }),
        (t += En));
  }
  return {
    tokens: e,
    end: t,
  };
}
export const On = Dn().tokens;
export const kn = Dn().end;
export const quickTimeline = {
  read: Cn,
  stream: Tn,
  streamEnd: kn,
  confirm: kn + 400,
  end: kn + 1e3,
};
export function jn(e) {
  return On.flatMap((t) => (t.kind === 'cite' && t.at <= e ? [t.n] : []));
}
export function Mn(e) {
  return e < Cn
    ? 0
    : Math.min(researchSources.length, Math.floor((e - Cn) / wn) + 1);
}
